import useSiteSettings from "../lib/useSiteSettings";
import { Hammer, House, Truck, CalendarClock } from "lucide-react";

const FEATURES = [
  [Hammer, "Handcrafted", "in Moradabad, India"],
  [House, "Collections for", "international buyers"],
  [Truck, "Bulk requirements", "discussed with our team"],
  [CalendarClock, "Materials & finishes", "for your sourcing brief"],
];

export default function FeatureStrip({ className = "" }) {
  const settings=useSiteSettings();
  const features=settings.features?settings.features.filter(item=>item.enabled!==false).map((item,i)=>[FEATURES[i%FEATURES.length][0],item.title,item.description]):FEATURES;
  return (
    <div className={`mx-auto max-w-5xl px-6 py-14 grid grid-cols-2 lg:grid-cols-4 gap-8 ${className}`} data-testid="feature-strip">
      {features.map(([Icon, a, b]) => (
        <div key={a} className="flex items-center gap-4 justify-center">
          <Icon className="w-9 h-9 text-mocha shrink-0" strokeWidth={0.9} />
          <p className="text-[12px] text-mocha leading-snug">
            {a}
            <br />
            {b}
          </p>
        </div>
      ))}
    </div>
  );
}
